export const cartSummaryHeight = $state({
	value: 0,
});
